




























































import {Component} from "vue-property-decorator";
import {Getter} from "vuex-class";
import ViewList from "@/views/List.vue";
import LineCheckList from "../../../components/admin/LineCheckList.vue";
import KeywordSearch from "@/components/forms/search/KeywordSearch.vue";

const components = {
    LineCheckList,
    KeywordSearch,
};

@Component({ components })
export default class AdminLineCheck extends ViewList {
    protected filters: object = {};

    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("isLoading") public isLoading!: boolean;
}
